/**
 * True only on the update where an already-loaded basket switched payment method.
 *
 * A basket arriving for the first time (the checkout page mounted before it loaded) is not a
 * change: treating it as one is what made CheckoutPage re-run checkout on every update.
 */
export const paymentMethodChanged = (prevBasket, basket) =>
  !!prevBasket && !!basket && prevBasket.paymentMethod !== basket.paymentMethod;
